import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectActualCompanyId } from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'
import { selectDateFilter, selectDateRange, selectWithoutScanback } from '../selectors'

import { INSIGHT_WIDGET_REQUEST_ASYNC } from './constants'

const getInsightsWidgetEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      INSIGHT_WIDGET_REQUEST_ASYNC.INITIATE,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .switchMap(() => {
      const state = store.getState()
      const companyId = selectActualCompanyId(state)
      const feDateRange = selectDateRange(state)
      const dateFilter = selectDateFilter(state)
      const emailDateRange = selectDateRange(state)
      const withoutScanback = selectWithoutScanback(state)

      const baseParams = {
        feDateRange,
        emailDateRange,
        withoutScanback,
        company_ids: [companyId],
        email_widget_type: ['Presumed phishing', 'Presumed spam'],
        classification: ['Phishing', 'Spam', 'Unclassified'],
        page_number: 1,
        page_size: 10000,
        logDateRange: null,
        custom_dates: Array.isArray(dateFilter),
        log_type: [
          'Suspicious email detected',
          'Suspicious email reported',
          'Email ignored (allow list)',
          'Classified as Phishing',
          'Classified as Spam',
          'Classified as Safe',
          'Reclassified as Phishing',
          'Reclassified as Spam',
          'Reclassified as Safe',
          'Revert to Phishing',
          'Revert to Spam',
          'Revert to Safe',
        ],
      }

      const queryTypes = ['current', 'previous', 'vip']

      return Observable.zip(
        ...queryTypes.map((queryType) =>
          api.dashboard.getInsightsWidget(companyId, { ...baseParams, queryType })
        )
      )
        .map((responses) => {
          const combinedResponse = responses.reduce(
            (acc, response) => ({ ...acc, ...response.response }),
            {}
          )
          return INSIGHT_WIDGET_REQUEST_ASYNC.onSuccess(combinedResponse)
        })
        .catch((error) =>
          Observable.of(epicsErrorHandler(INSIGHT_WIDGET_REQUEST_ASYNC.onError, error))
        )
        .takeUntil(
          action$.ofType(INSIGHT_WIDGET_REQUEST_ASYNC.CANCEL, INSIGHT_WIDGET_REQUEST_ASYNC.ERROR)
        )
    })

export default combineEpics(getInsightsWidgetEpic)
